import { Button, Divider, Form, Input, Select, Skeleton, TimePicker } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import "./index.css"
import { useNavigate, useSearchParams } from 'react-router-dom'
import API from 'API'
import InvitationsTable from 'components/InvitationsTable'
import dayjs from 'dayjs';

const groups = [
    { value: "bancuabo", label: "Bạn của bố" },
    { value: "bancuame", label: "Bạn của mẹ" },
    { value: "nguoithan", label: "Người thân" },
    { value: "hangxom", label: "Hàng xóm" },
    { value: "hohang", label: "Họ hàng" },
]

const initialValues = {
    group: "bancuabo",
    self_pronoun: "Chúng cháu",
    open_time: dayjs("16:00", "HH:mm"),
}

const self_pronoun_options = [
    { value: "Chúng cháu", label: "Chúng cháu" },
]

const customer_address_term_options = [
    { value: "Cô", label: "Cô" },
    { value: "Dì", label: "Dì" },
    { value: "Chú", label: "Chú" },
    { value: "Bác", label: "Bác" },
    { value: "Cậu", label: "Cậu" },
    { value: "Thím", label: "Thím" },
    { value: "Mợ", label: "Mợ" },
    { value: "Dượng", label: "Dượng" },
]

const labels = {
    name: "Tên",
    displayname: "Tên hiển thị",
    group: "Nhóm",
    open_time: "Thời gian nhập tiệc",
    self_pronoun: "Xưng hô",
    customer_address_term: "Cách gọi khách"
}

export { self_pronoun_options, customer_address_term_options}

export default function InvitationForm() {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const q = searchParams.get("q");
    const navigate = useNavigate();
    const [invitations, setInvitations] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        if (!q) {
            navigate("/");
        }
        API.get(`get-invitation-list/?token=${q}`)
            .then(res => {
                setInvitations(res.data);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status === 400) {
                    navigate("/");
                }
            })
    }, [q, navigate])

    const onSubmit = useCallback((values) => {
        setSubmitting(true);
        const open_time = values.open_time.format("HH:mm");
        API.post(`get-invitation-list/?token=${q}`, {
            ...values,
            open_time: open_time,
            ritual_time: open_time,
            party_time: open_time,
        })
            .then(res => {
                setInvitations(invitations => [res.data, ...invitations]);
                form.resetFields();
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setSubmitting(false);
            })
    }, [q, form])

    return loading ? <Skeleton active /> : <div className='invitation-form-div'>
        <Divider>
            Tạo khách mời
        </Divider>
        <Form
            id='invitation-form'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            onFinish={onSubmit}
            initialValues={initialValues}
            form={form}
        >
            <Form.Item
                name="group"
                label="Nhóm"
                rules={[
                    { required: true, message: "Bố chọn nhóm đi ạ!" }
                ]}
            >
                <Select options={groups} />
            </Form.Item>
            <Form.Item
                name="name"
                label="Tên"
                rules={[
                    { required: true, message: "Bố nhập tên đi ạ!" }
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name="displayname"
                label="Tên hiển thị"
                rules={[
                    { required: true, message: "Bố nhập tên hiển thị đi ạ!" }
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name="open_time"
                label="Thời gian nhập tiệc"
                rules={[
                    { required: true, message: "Bố chọn thời gian nhập tiệc đi ạ!" }
                ]}
            >
                <TimePicker />
            </Form.Item>
            <Form.Item
                name="self_pronoun"
                label="Xưng hô"
                rules={[
                    { required: true, message: "Bố chọn xưng hô đi ạ!" }
                ]}
            >
                <Select options={self_pronoun_options} />
            </Form.Item>
            <Form.Item
                name="customer_address_term"
                label="Cách gọi khách"
                rules={[
                    { required: true, message: "Bố chọn cách gọi khách đi ạ!" }
                ]}
            >
                <Select options={customer_address_term_options} />
            </Form.Item>
            <div style={{ textAlign: "right" }}>
                <Button htmlType='submit' type='primary' loading={submitting}>
                    Tạo
                </Button>
            </div>
        </Form>
        <Divider>
            Danh sách khách mời
        </Divider>
        <InvitationsTable
            invitations={invitations}
            tab="hanoi"
            setInvitations={setInvitations}
            deletable
            labels={labels}
            excludeColumns={["party_time", "ritual_time"]}
            />
    </div>
}
